<template>
  <div class="inputSearch" v-bind:data-epica-module-name="epicaModule">
    <i class="quoteSearch icon-search"></i>
    <multiselect
      deselect-label
      select-label
      track-by="name"
      label="name"
      :options="acResult"
      :multiple="false"
      placeholder="Buscar indicador"
      :show-no-results="false"
      @search-change="searchQuote"
      @select="selectOpt"
    >
      <template slot="noOptions">
        <span v-html="'Consulte el indicador económico'"></span>
      </template>
    </multiselect>
  </div>
</template>

<script>
import debounce from "lodash/debounce";
import axios from "axios";
import Multiselect from "vue-multiselect";
export default {
  components: {
    Multiselect,
  },
  props: {
    epicaModule: String,
  },
  methods: {
    searchQuote: debounce(function (topic) {
      const _self = this;
      if (topic) {
        const params = {
          term: topic,
        };
        axios.get("/api/quote/ac", { params }).then(function (d) {
          _self.acResult = d.data.quotes;
        });
      } else {
        this.clean();
      }
    }, 250),
    selectOpt: function (opt) {
      window.location.href = "/redirect/" + opt.acType + "/" + opt.id;
    },
    clean: function () {
      this.acResult = [];
    },
  },
  data: function () {
    return {
      acResult: [],
    };
  },
};
</script>
